import {useEffect} from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';
import useBrandId from '@/hooks/use-brand-id';
import useToken from '@/hooks/use-token';

function useRedirectToCampaignsIfAuthenticated() {
  const {initialized, isAuthenticated} = useToken();
  const {campaignId} = useParams<{campaignId: string}>();
  const {pathname, search} = useLocation();
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();
  const brandId = useBrandId();

  useEffect(() => {
    if (initialized && !isAuthenticated && brandId) {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.delete('brandId');
        return next;
      });
    }

    if (!initialized || !isAuthenticated || !campaignId) {
      return;
    }

    const offPlatformBase = `${ROUTES.OFF_PLATFORM_REVIEW}/${campaignId}`;
    const subPath = pathname.replace(offPlatformBase, '');
    const onPlatformPath = `${ROUTES.CAMPAIGNS_V2}/${campaignId}/assets${subPath}`;

    // The share token is an off-platform capability — keep it out of
    // authenticated dashboard URLs (history, analytics).
    const onPlatformParams = new URLSearchParams(search);
    onPlatformParams.delete('token');
    const onPlatformSearch = onPlatformParams.toString();

    navigate(
      `${onPlatformPath}${onPlatformSearch ? `?${onPlatformSearch}` : ''}`,
      {
        replace: true,
      }
    );
  }, [
    initialized,
    isAuthenticated,
    brandId,
    campaignId,
    pathname,
    search,
    navigate,
  ]);

  return {isCheckingAuth: !initialized};
}

export default useRedirectToCampaignsIfAuthenticated;
